import { valueOf } from "@/types/common";

export const FILE_STATUS = {
  IN_PROGRESS: 0,
  OK: 1,
  ERROR: 2,
  ERROR_MIN_SIZE: 3,
  ERROR_MAX_SIZE: 4,
  ERROR_ACCEPT_FILES: 5,
};

export type TFileStatus = valueOf<typeof FILE_STATUS>;

export const FILE_ERROR_MESSAGE = {
  [FILE_STATUS.ERROR]: "FILE is invalid",
  [FILE_STATUS.ERROR_MAX_SIZE]: "ファイルサイズは{{maxSize}}MB以内でお願いします。",
  [FILE_STATUS.ERROR_MIN_SIZE]: "lt {{minSize}}MB。",
  [FILE_STATUS.ERROR_ACCEPT_FILES]: "ファイル形式は{{extensions}}にてお願いします。",
};

export const MAX_SIZE_ERROR = (maxSize: number) => `ファイルサイズは${Math.floor(maxSize / 1000)}KB以下にしてください。`;
export const ACCEPT_ERROR = (extension: string[]) => `アップロード可能なファイル形式は${extension.join("、")} です。`;

export const FILE_UPLOAD_FOR = {
  INFORMATION_FILE: "INFORMATION_FILE",
  CHAT_FILE: "CHAT_FILE",
  CONVERT_REQUEST_FILE: "CONVERT_REQUEST_FILE",
};

export type TFileUploadFor = valueOf<typeof FILE_UPLOAD_FOR>;

export const MIME_TYPES = {
  IMAGE: ["image/jpg", "image/jpeg", "image/gif", "image/png"],
  HEIC: ["image/heic", "image/heif"],
  PDF: ["application/pdf"],
  EXCEL: ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/xml", "text/xml", "text/csv"],
  WORD: ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/x-ole-storage"],
  TXT: ["text/plain"],
  CSV: ["text/csv"],
  XML: ["application/xml", "text/xml"],
  STACK: [
    "application/zip",
    "application/x-zip-compressed",
    "application/vnd.rar",
    "application/x-rar-compressed",
    "application/x-rar",
    "multipart/x-rar",
    ".rar",
    "rar",
  ],
  PPT: ["application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
};

export const EXTENSION_NAMES: Record<string, string> = {
  IMAGE: "Word",
  HEIC: "HEIC",
  PDF: "PDF",
  EXCEL: "Excel",
  WORD: "Word",
  TXT: "Txt",
  CSV: "CSV",
  XML: "XML",
};

export const EXTENSIONS = {
  IMAGE: [".jpg", ".jpeg", ".png", ".gif"],
  DOC: [".doc", ".docx"],
  PDF: [".pdf"],
  EXCEL: [".xlsx", ".csv"],
  XML: [".xml"],
};

export const COMMON_MINE_TYPES = [
  "application/pdf", //pdf
  "application/msword", //doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", //doc
  "application/x-ole-storage", //docx
  "application/vnd.ms-excel", //xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", //xlsx
  "text/csv", //csv
  "application/vnd.ms-powerpoint", // ppt
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", //pptx
  "text/plain", //txt
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "application/vnd.rar",
  "application/x-rar-compressed",
  "application/x-rar",
  "application/x-compressed",
  "multipart/x-rar",
  "application/zip",
  "application/x-zip",
  "application/x-zip-compressed",
];

export const COMMON_FILE_TYPES_EXTENSION = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".csv",
  ".ppt",
  ".pptx",
  ".txt",
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".rar",
  ".zip",
];
